import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ImageService } from '../../services/image/image.service';
import { ScriptService } from '../../services/load.script/load.script.service';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'ig-rich-text-box',
  templateUrl: './rich.text.box.component.html',
  styleUrls: ['./rich.text.box.component.scss'],
})
export class RichTextBoxComponent implements OnInit {
  @Input() public description: string;
  @Output() public descriptionChange = new EventEmitter<string>();

  descriptionEditor: any;
  isEditDescription = false;
  isDescriptionNeedShowMore = false;

  imageService = inject(ImageService);
  scriptService = inject(ScriptService);

  @ViewChild('description') public descriptionArea: ElementRef;
  @ViewChild('descriptionHtml') public descriptionHtml: ElementRef;
  @ViewChild('menuTrigger') public menuTrigger: MatMenuTrigger;

  constructor() {}

  ngOnInit() {
    this.setUpHtmlEditor();
    this.adjustTextareaHeight();
  }

  setUpHtmlEditor() {
    setTimeout(() => {
      this.descriptionEditor = window['SUNEDITOR'].create('description-editor', {
        toolbarContainer: '#toolbar_container',
        showPathLabel: false,
        charCounter: true,
        width: 'auto',
        height: 'auto',
        minHeight: '100px',
        maxHeight: '250px',
        value: this.description || '',
        buttonList: [
          ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
          ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'removeFormat'],
          [
            'fontColor',
            'hiliteColor',
            'outdent',
            'indent',
            'align',
            'horizontalRule',
            'list',
            'table',
          ],
          ['link', 'image', 'video', 'fullScreen', 'showBlocks', 'codeView', 'preview', 'print'],
        ],
      });

      this.descriptionEditor.onImageUploadBefore = (files, info, core, uploadHandler) => {
        try {
          this.handleImageUploadBefore(files, info, uploadHandler);
        } catch (err) {
          uploadHandler(err.toString());
        }
      };

      this.descriptionEditor.onChange = (contents) => {
        this.descriptionChange.emit(contents);
      };
    });
  }

  getEditorContent(): string {
    if (this.descriptionEditor) {
      return this.descriptionEditor.getContents();
    }
    return '';
  }

  setEditorContent(content: string): void {
    if (this.descriptionEditor) {
      this.descriptionEditor.setContents(content);
    }
  }

  private adjustTextareaHeight() {
    setTimeout(() => {
      if (this.descriptionArea && this.descriptionArea.nativeElement) {
        this.descriptionArea.nativeElement.style.height =
          Math.min(this.descriptionArea.nativeElement.scrollHeight, 300) + 'px';
      }
      if (this.descriptionHtml) {
        this.isDescriptionNeedShowMore = this.descriptionHtml.nativeElement.scrollHeight > 150;
      }
    });
  }

  private handleImageUploadBefore(files, info, uploadHandler) {
    this.imageService
      .getBase64ByImageFile(files[0])
      .then((imageInfo) => {
        if (imageInfo) {
          this.imageService.uploadBase64ImageToAWS(imageInfo).subscribe((res) => {
            if (res.success) {
              const response = {
                result: [
                  {
                    url: `${res.url}`,
                    name: files[0].name,
                    size: files[0].size,
                  },
                ],
              };
              uploadHandler(response);
            } else {
              uploadHandler('upload image fail');
            }
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
